import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
}
export function Button({
  variant = 'primary',
  children,
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-bold uppercase tracking-wider text-sm shadow-md transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-fil-terra';
  const variants = {
    primary: 'bg-fil-terra text-white hover:bg-fil-terra-dark',
    secondary: 'bg-fil-sage-dark text-white hover:bg-fil-cocoa'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={onClick} {...props} data-id="element-212" data-mp="32i7qo8edbyb">
      {children}
    </motion.button>;
}
export function scrollToPurchase() {
  document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
}